/* What the browser apps (apps/web, apps/extension, apps/planner) may import: everything except the server-only field
   encryption and data export, which use node:crypto. app-links (the phone app's links) needs the DOM, so it is only here,
   not in index.ts. */
export * from './age';
export * from './guards';
export * from './classify';
export * from './plans';

// AI: the AI guide and essay feedback
export * from './safety';
export * from './helplines';

// reminders: WhatsApp and email
export * from './reminders';

// parents: progress page and "parent pays"
export * from './family';

// the extension and the site working as one (no pairing codes to type)
export * from './extension-link';

// the phone app: links open in its own browser, where portals get the fill button
export * from './app-links';

export { EXTENSION_FIELDS, ROUTES, ENV_VARS, OPTIONAL_ENV, WEB_ROUTES, COOKIE_ACCESS, COOKIE_REFRESH, CSRF_HEADER, LANGS, LANG_NAMES, isLang, asLang, langDir } from './contract';
export type * from './contract';
